export enum METALS {
  'PLATINUM' = 'platinum',
  'PALLADIUM' = 'palladium',
  'RHODIUM' = 'rhodium',
}
